// Single source of truth for speakers. Referenced from both Speakers.jsx
// and Program.jsx so titles/positions are identical everywhere on the site.

export const SPEAKERS = [
  {
    slug: "ivo-dimovski",
    name: "Иво Димовски",
    role: "Организатор и инвеститор в недвижими имоти",
    photo: "/speakers/ivo-dimovski.png",
  },
  {
    slug: "svetoslav-jekov",
    name: "Светослав Жеков",
    role: "Председател на Камарата на строителите във Варна",
    photo: "/speakers/svetoslav-jekov.jpg",
  },
  {
    slug: "hristo-dimitrov",
    name: "Христо Димитров",
    role: "Председател на Общински съвет – Варна",
    photo: "/speakers/hristo-dimitrov.png",
  },
  {
    slug: "penko-stoyanov",
    name: "инж. Пенко Стоянов",
    role: "Дългогодишен представител на Камарата на строителите в България (КСБ)",
    photo: "/speakers/penko-stoyanov.png",
  },
  {
    slug: "petar-kirov",
    name: "Петър Киров",
    role: "Директор на UniCredit Bulbank – филиал „Варна – Черно море\"",
    photo: "/speakers/petar-kirov.png",
  },
  {
    slug: "daniel-georgiev",
    name: "Даниел Георгиев",
    role: "Бизнес собственик и сериен инвеститор във fix & flip имоти във Варна",
    photo: "/speakers/daniel-georgiev.png",
  },
  {
    slug: "svetoslav-hristov",
    name: "Светослав Христов",
    role: "Мениджър екип, ERA Недвижими имоти – офис Вива, Варна",
    photo: "/speakers/svetoslav-hristov.png",
  },
  {
    slug: "svetoslav-dinev",
    name: "Светослав Динев",
    role: "Директор „Продажби\", NEW TOWER",
    photo: "/speakers/svetoslav-dinev.png",
  },
  {
    slug: "nadezhda-yaneva",
    name: "Надежда Янева",
    role: "Директор „Развитие\" на CreditZone за Варна",
    photo: "/speakers/nadezhda-yaneva.png",
  },
  {
    slug: "kristian-kostov",
    name: "Кристиян Костов",
    role: "Дългогодишен журналист и сериен инвеститор",
    photo: "/speakers/kristian-kostov.png",
  },
  {
    slug: "mira-kuzmanova",
    name: "Мира Кузманова",
    role: "Директор, Academy за имоти",
    photo: "/speakers/mira-kuzmanova.jpg",
  },
  {
    slug: "stefan-stoykov",
    name: "Стефан Стойков",
    role: "Управител на S Properties",
    photo: "/speakers/stefan-stoykov.png",
  },
  {
    slug: "miroslav-vladimirov",
    name: "гл. ас. д-р Мирослав Владимиров",
    role: "Член на Съвета на директорите на ЕРА България АД",
    photo: "/speakers/miroslav-vladimirov.png",
  },
  {
    slug: "rumyana-dimitrova",
    name: "Румяна Димитрова",
    role: "Управител и собственик ERA VARNA TREND",
    photo: "/speakers/rumyana-dimitrova.png",
  },
  {
    slug: "hristo-petrov",
    name: "Христо Петров",
    role: "Счетоводител и собственик на Golden Vision",
    photo: "/speakers/hristo-petrov.png",
  },
  {
    slug: "rostislav-totev",
    name: "Ростислав Тотев",
    role: "Предприемач и собственик на Altcoins.bg",
    photo: "/speakers/rostislav-totev.png",
  },
  {
    slug: "yani-marinov",
    name: "Яни Маринов",
    role: "Гост лектор",
  },
  {
    slug: "elitsa-panayotova",
    name: "Арх. Елица Панайотова",
    role: "Архитект · Гранд Хотел Варна",
  },
  {
    slug: "magdalena-todorova",
    name: "Магдалена Тодорова",
    role: "Водещ",
    photo: "/speakers/magdalena-todorova.png",
  },
];

export const SPEAKERS_BY_SLUG = SPEAKERS.reduce((acc, s) => {
  acc[s.slug] = s;
  return acc;
}, {});

// Program items reference speakers by slug; UI reads role/name from SPEAKERS.
export const PROGRAM = [
  { time: "08:45 – 09:30", type: "meta", title: "Регистрация", subtitle: "Посрещане и регистрация на гостите" },
  {
    time: "09:30 – 09:45",
    title: "Откриване на събитието",
    speakers: ["ivo-dimovski", "svetoslav-jekov"],
  },
  {
    time: "09:45 – 10:10",
    title: "„Ускорение“: Една икономика. Три скорости. Какво показват данните отвъд заглавието?",
    speakers: ["petar-kirov"],
    sponsor: "Главен спонсор: УниКредит Булбанк",
    highlight: "unicredit",
  },
  {
    time: "10:10 – 10:30",
    title: "Какво се случва с имотите по света и какво идва към България скоро?",
    speakers: ["rumyana-dimitrova"],
  },
  {
    time: "10:30 – 10:55",
    title: "Как всъщност се правят пари от имоти във Варна през 2026 г.?",
    speakers: ["daniel-georgiev", "yani-marinov", "ivo-dimovski"],
    moderators: ["ivo-dimovski", "mira-kuzmanova"],
  },
  {
    time: "10:55 – 11:10",
    title: "Как създадохме най-добрия клуб за инвеститори в имоти в България и чужбина",
    speakers: ["mira-kuzmanova"],
    subtitle: "Академията за Имоти",
    moderators: ["ivo-dimovski", "mira-kuzmanova"],
  },
  {
    time: "11:10 – 11:30",
    title: "Как да вземеш брутално изгоден ипотечен кредит през 2026 г.?",
    speakers: ["nadezhda-yaneva"],
    subtitle: "CreditZone",
    moderator: "kristian-kostov",
  },
  { time: "11:30 – 11:50", type: "meta", title: "Кафе пауза", icon: "coffee" },
  {
    time: "11:50 – 12:10",
    title: "NEW TOWER: сделката във Варна, която си струва да видите отвътре",
    speakers: ["svetoslav-dinev"],
  },
  {
    time: "12:10 – 12:45",
    title: "Инфраструктурни решения за гр. Варна",
    speakers: ["hristo-dimitrov", "penko-stoyanov", "svetoslav-jekov"],
    subtitle: "КСБ Варна",
    moderator: "magdalena-todorova",
  },
  { time: "12:45 – 13:45", type: "meta", title: "Обяд", icon: "food" },
  {
    time: "13:45 – 14:05",
    title: "Апартаментът през 2035 г. няма да изглежда така, както си мислите",
    speakers: ["svetoslav-jekov"],
  },
  {
    time: "14:05 – 14:25",
    title: "Ще се вдигнат ли данъците на имотите в България?",
    speakers: ["hristo-petrov"],
    moderator: "ivo-dimovski",
  },
  {
    time: "14:25 – 14:45",
    title: "Бъдещето на купуването на имоти: купувачът през 2035 г.",
    speakers: ["stefan-stoykov"],
    moderator: "kristian-kostov",
  },
  {
    time: "14:45 – 15:05",
    title: "Гранд Хотел Варна: Една легенда има нов живот",
    speakers: ["elitsa-panayotova"],
  },
  {
    time: "15:05 – 15:30",
    title: "Потенциалът на нашия град Варна",
    subtitle: "Камара на строителите – Варна · гл. арх. Венелин Марков",
    moderator: "ivo-dimovski",
  },
  {
    time: "15:30 – 15:45",
    title: "Капитал без граници: от недвижими имоти до дигитални активи",
    speakers: ["rostislav-totev"],
    subtitle: "Altcoins.bg — партньор за дигитални активи",
    moderator: "kristian-kostov",
  },
  {
    time: "15:45 – 16:05",
    title: "Прогнозата за пазара на имоти 2027–2028: какво ще се случи с цените на имотите?",
    speakers: ["miroslav-vladimirov"],
    moderator: "kristian-kostov",
  },
  { time: "16:05 – 16:30", type: "meta", title: "Кафе пауза", icon: "coffee" },
  {
    time: "16:30 – 18:00",
    title: "Церемония „Златен Отвес“",
    subtitle: "Кметът на Варна и официални лица · Официална церемония по награждаване",
    highlight: "award",
  },
  {
    time: "18:00 – 18:30",
    title: "Закриване на събитието и GIVEAWAY",
    speakers: ["ivo-dimovski"],
    subtitle: "с Леонидас",
  },
  {
    time: "18:30 – 19:00",
    title: "„Баба Алино и как държавата проспа това“",
    subtitle: "VIP ONLY · Гост изненада · Limited access",
    highlight: "vip",
    tba: "Името на VIP госта ще бъде разкрито на събитието",
  },
];
